import { type ChatInterface } from "@mlc-ai/web-llm";
import { getEmbeddings } from "../../../candle-wasm-bert/utils.js";
const bertWorker = new Worker(new URL('../../../candle-wasm-bert/bertWorker.js', import.meta.url), {
  type: "module",
});

import { createActor } from "../declarations/instance/index.js";
import { ActorSubclass } from "@dfinity/agent";
import { _SERVICE } from "../declarations/instance/instance.did.js";
const canister: ActorSubclass<_SERVICE> = createActor("6n4um-kiaaa-aaaak-afdlq-cai", { agentOptions: { host: 'https://ic0.app' } });

import { HfInferenceEndpoint } from '@huggingface/inference'
import llamaTokenizer from 'llama-tokenizer-js'

const llmSeverLink = 'https://m8tm9gbtmqg9dr28.us-east-1.aws.endpoints.huggingface.cloud';


export default class ServerChatUI {
  private chat: ChatInterface;
  private chatLoaded = false;
  public requestInProgress = false;
  // We use a request chain to ensure that
  // all requests send to chat are sequentialized
  private chatRequestChain: Promise<void> = Promise.resolve();

  constructor(chat: ChatInterface) {
    this.chat = chat;
  }
  /**
   * Push a task to the execution queue.
   *
   * @param task The task to be executed;
   */
  private pushTask(task: () => Promise<void>) {
    const lastEvent = this.chatRequestChain;
    this.chatRequestChain = lastEvent.then(task);
  }
  // Event handlers
  // all event handler pushes the tasks to a queue
  // that get executed sequentially
  // the tasks previous tasks, which causes them to early stop
  // can be interrupted by chat.interruptGenerate
  async onGenerate(prompt: string, messageUpdate: (kind: string, text: string, append: boolean) => void, setRuntimeStats: (runtimeStats: string) => void) {
    if (this.requestInProgress) {
      return;
    }
    this.pushTask(async () => {
      await this.asyncGenerate(prompt, messageUpdate, setRuntimeStats);
    });
    return this.chatRequestChain;
  }

  async onReset(clearMessages: () => void) {
    if (this.requestInProgress) {
      // interrupt previous generation if any
      this.chat.interruptGenerate();
    }
    // try reset after previous requests finishes
    this.pushTask(async () => {
      await this.chat.resetChat();
      clearMessages();
      history_array = [];
    });
    return this.chatRequestChain;
  }

  async asyncInitChat(prompt: string, messageUpdate: (kind: string, text: string, append: boolean) => void) {
    if (this.chatLoaded) return;
    this.requestInProgress = true;
    // messageUpdate("init", "", true);
    // const initProgressCallback = (report: { text: string; }) => {
    //   messageUpdate("init", report.text, false);
    // };
    // this.chat.setInitProgressCallback(initProgressCallback);

    
    const headers = {
      "Authorization": `Bearer ${accessToken}`, // Header has a read only access token.
      "Content-Type": "application/json"
    };

    messageUpdate("init", "Connecting LLM server...", false);

    try {
      const response = await fetch(llmSeverLink + '/info', {
        method: "GET",
        headers: headers
      });
      
      console.log(response.status)
      if (response.status >= 200 && response.status < 300) {
        console.log('Server is healthy');
        messageUpdate("init", "Server is online", false);
        this.requestInProgress = false;
        this.chatLoaded = true;
      } else {
        console.error('Server is not healthy');
        messageUpdate("error", "Sorry, now server is down. Please try local llm.", false);
      }
    } catch (error) {
      messageUpdate("error", "Error while checking server health: " + error, true);
    }
  }

  private async unloadChat() {
    await this.chat.unload();
    this.chatLoaded = false;
  }

  /**
   * Run generate
   */
  private async asyncGenerate(user_prompt: string, messageUpdate: (kind: string, text: string, append: boolean) => void, setRuntimeStats: (runtimeStats: string) => void) {
    await this.asyncInitChat(user_prompt, messageUpdate);
    this.requestInProgress = true;

    if (user_prompt == "") {
      this.requestInProgress = false;
      return;
    }


    messageUpdate("user", user_prompt, true);

    messageUpdate("llm", "", true);

    const callbackUpdateResponse = (msg: string) => {
      messageUpdate("llm", msg, false);
    };

    try {
      // Get embedding representation of user prompt.
      const bert_query = "query: " + user_prompt; // add search prefix
      const model_base_url = "https://huggingface.co/intfloat/e5-small-v2/resolve/main/";
      const bert_res = await getEmbeddings(
        bertWorker,
        model_base_url + "model.safetensors",
        model_base_url + "tokenizer.json",
        model_base_url + "config.json",
        "intfloat_e5_small_v2", // model id
        [bert_query]
      );
      const embedding = bert_res.output[0];
      let response = await canister.search_query_v2(user_prompt, embedding, 500); // The third arg is length of summary in response.
      let url = response[0][0][1]; // Source URL
      let overview = response[0][0][1]; // Overview of the page which corresponding to the above URL.
      let summary = response[1]; // Summary of the page.

      // Augment user prompt with result of semantic search on canister.
      const augmented_user_prompt = 
      `Context information is below.
      ---------------------
      ${url}

      ${overview.split('\n').slice(0, 2)}

      ${summary}
      ---------------------
      Given the context information and not prior knowledge, answer the query.
      Query: ${user_prompt}
      Answer:
      "`
      
      // Make prompt format to be fed to llm.
      const prompt = history_array.join("") + `<s>[INST]${augmented_user_prompt}[/INST]`; // Note: To get the LLM to answer, do not end with </s>.
      // If the prompot is over context window size, cutting the history.
      const window_size = 4000;
      const prompt_length = llamaTokenizer.encode(prompt).length;
      let history_text = prompt;
      if (prompt_length + 512 >= window_size) { // 512 is `max_new_tokens` size.
        // console.log("prompt is over context size")
        // console.log(prompt_length)
        for (let i=1; i<history_array.length; i++) {
          history_text = history_array.slice(i).join("") + `<s>[INST]${augmented_user_prompt}[/INST]`;
          const new_len = llamaTokenizer.encode(history_text).length + 512;
          // console.log(new_len)
          if (new_len < window_size) {
            break;
          };
        }
      }

      // Pass prompt to llm and get answer.
      const llm_answer = await ask(history_text, callbackUpdateResponse);

      // Make chat history but exclude context information because if we add it to history, history length is easly over context length.
      // history_text =  history_text + `<s>[INST]${user_prompt}[/INST]` + `${llm_answer}`; // Should be end with </s>.
      // console.log(`\n[LLM]${llm_answer}`)
      // console.log(`\nhistory:\n${history_text}`)

      // console.log(llamaTokenizer.encode(history_text).length);

      history_array.push(`<s>[INST]${user_prompt}[/INST]` + llm_answer);


      
      // Update chat log.
      messageUpdate("llm", llm_answer.slice(0, -4), false); // delete "</s> characters.


    } catch (err: unknown) {
      messageUpdate("error", "Generate error, " + (err?.toString() ?? ""), true);
      console.log(err);
      await this.unloadChat();
    }


    this.requestInProgress = false;
  }
}


let history_array: string[] = [];
const accessToken = process.env.HUGGINGFACE_READ_ONLY_ACCESS_TOKEN;

async function ask(prompt: string, callbackUpdateResponse) {

  const hf = new HfInferenceEndpoint(llmSeverLink, accessToken)

  let fullText = '';
  const stream = hf.textGenerationStream({
    inputs: prompt,
    parameters: {max_new_tokens: 512},
  });
  for await (const r of stream) { 
    const token_text = r.token.text;
    fullText += token_text;
    // console.log(token_text)
    callbackUpdateResponse(fullText)
  }
  // console.log(stream)

  return fullText;

}

function messageUpdate(fullText: string) {
  throw new Error("Function not implemented.");
}
